import { createContext, useContext } from 'react';
import { ICatalog, ICatalogKind, ICatalogForm } from 'src/lib/schemas';

export interface ICatalogsContext {
	catalogKinds: ICatalogKind[];
	isLoading: boolean;
	error: Error | null;
	refetch: () => Promise<void>;
	catalogs: ICatalog[];
	getCatalogById: (id: string) => ICatalog | undefined;
	updateCatalog: (payload: ICatalogForm) => Promise<ICatalog>;
}

const CatalogsContext = createContext<ICatalogsContext | undefined>(undefined);

export const useCatalogsContext = () => {
	const ctx = useContext(CatalogsContext);
	if (!ctx)
		throw new Error(
			'useCatalogsContext must be used within a CatalogsProvider',
		);
	return ctx;
};

export { CatalogsContext };
